import React from "react";
import ReactDom from "react-dom";
import VideoCanvas from "./video-canvas";
import ImageCanvas from "./image-canvas";
import ContentCanvas from "./content-canvas";

export default class Carousel extends React.Component {

    render() {
        const { item } = this.props;

        return (
            <div className="gallery-carousel">
                <div className="gallery-carousel-prev" onClick={this.props.onPrev}><span /></div>
                <div className="gallery-carousel-item active">
                    {item.type === "video" && <VideoCanvas url={item.contentUrl} autoplay={item.autoPlay} videoid={item.id} />}
                    {item.type === "photo" && <ImageCanvas url={item.contentUrl} />}
                    {item.type === "content" && <ContentCanvas url={item.contentUrl} onNext={this.props.onPrevOrNext} />}
                </div>
                <div className="gallery-carousel-next" onClick={this.props.onNext}><span /></div>
            </div>
        );
    }

}